/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { LinkedList, Node } from "dc-preview-utils/src/Utils/LinkedListUtils";
import { SearchResult } from "./SearchResult";

class SearchResults {
  constructor() {
    this.listOfSearchResults = new LinkedList();
  }

  get length() {
    return this.listOfSearchResults ? this.listOfSearchResults.length : 0;
  }

  isEmpty() {
    return this.listOfSearchResults === null || this.listOfSearchResults.length === 0;
  }

  getHead() {
    return this.listOfSearchResults.getHead();
  }

  mergeNewSearchResults(searchResultsOnPages) {
    searchResultsOnPages.forEach(searchResultsOnPage => {
      searchResultsOnPage.searchResults.forEach(searchResult => {
        const newNode = new Node(
          "searchResult",
          new SearchResult({
            pageIndex: searchResultsOnPage.pageIndex,
            quads: searchResult,
            searchResultIndex: this.listOfSearchResults.length + 1
          })
        );
        this.listOfSearchResults.insertNodeAtEnd(newNode);
      });
    });
  }

  forEach(callback) {
    this.listOfSearchResults.forEach(callback);
  }
}

export { SearchResults };
